import { createTheme } from "@mui/material";

// Create theme
const theme = createTheme({
    palette: {
      primary: {
        main: '#2C6CA0',
      },
      secondary: {
        main: '#dc004e',
      },
    },
    typography: {
      fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    },
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          notchedOutline: {
            borderColor: '#C8CEE3',
          },
          root: {
            backgroundColor: '#ffffff',
            borderRadius: 8,
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#2C6CA0',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#2C6CA0',
            },
          },
          input: ({ ownerState }: any) =>
            ownerState?.size === 'small'
              ? { padding: '10px 12px' }
              : {},
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            '& .MuiOutlinedInput-root': {
              borderRadius: 8,
              backgroundColor: '#ffffff',
            },
          },
        },
      },
      MuiSelect: {
        styleOverrides: {
          select: ({ ownerState }: any) =>
            ownerState?.size === 'small'
              ? { padding: '10px 12px' }
              : {},
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            padding: '8px 16px',
            borderRadius: 8,
            textTransform: 'none',
          },
          outlined: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: 600,
            fontSize: '16px',
            lineHeight: '100%',
            letterSpacing: '0px',
            textAlign: 'center',
            backgroundColor: '#FFFFFF',
            border: '1px solid var(--border-Color, #C8CEE3)',
            color: '#222b45d6',
            padding: '13px 48px'
          },
          contained: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: 600,
            fontSize: '16px',
            lineHeight: '100%',
            letterSpacing: '0px',
            textAlign: 'center',
            backgroundColor: '#2C6CA0',
            color: '#ffffff',
            padding: '14px 48px'
          },
          sizeSmall: {
            padding: '6px 12px',
          },
          sizeLarge: {
            padding: '10px 20px',
          },
        },
      },
      MuiDialogActions: {
        styleOverrides: {
          root: {
            padding: '16px',
            borderTop: '1px solid #C8CEE3'
          },
        },
      },
      MuiDialog: {
        styleOverrides: {
          paper: {
            borderRadius: 8,
            msOverflowStyle: 'none',
            scrollbarWidth: 'none',
            '&::-webkit-scrollbar': {
              width: 0,
              height: 0,
            },
          },
        },
      },
      MuiDialogContent: {
        styleOverrides: {
          root: {
            overflowX: 'hidden',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            '&::-webkit-scrollbar': {
              width: 0,
              height: 0,
            },
          },
        },
      },
      MuiDialogTitle: {
        styleOverrides: {
          root: {
            fontFamily: 'Inter, sans-serif',
            fontWeight: 600,
            fontSize: '20px',
            lineHeight: '30px',
            letterSpacing: '0px',
            marginBottom: '24px',
          },
        },
      },
      
    },
  });
  
export { theme as MuiTheme }